import { z } from "zod";
import { connectCodeSchema } from "./post-connect-organization.schema";

/** The path of the connect preview: the invitation code the caller is about to redeem. */
export const getConnectPreviewParamSchema = z.object({
	code: connectCodeSchema,
});

export type GetConnectPreviewParamSchema = z.infer<typeof getConnectPreviewParamSchema>;
